import { orderBy } from 'lodash';
import courts from '../../../data/courts';


const sortedCourts = orderBy(courts, ['name'], ['asc']);

export default function (type, replacementSuffix) {
  return sortedCourts
    .filter(p => p.type === type)
    .reduce((accum, next) => {
      const name = next.name.replace(replacementSuffix, '').trim();
      return Object.assign(accum, { [next.code]: name });
    }, {});
}



/** WEBPACK FOOTER **
 ** ./src/pages/filings/SearchCourtRecords/courtsMapper.js
 **/